var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.001,
    viewBox: "0 0 20 20.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(0 -3.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M3,24H17a3,3,0,0,0,3-3V18.48a1,1,0,1,0-2,0V21a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V19.544c-.669.027.066-.1-2-.128V21a3,3,0,0,0,3,3Z",
    transform: "translate(0 0)",
    fill: "#003984"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M21.076.011a2.567,2.567,0,0,0-2.049.721L10.1,9.655a.993.993,0,0,0-.286.589l-.381,3.209a1,1,0,0,0,.993,1.118.945.945,0,0,0,.118-.007l3.209-.381a.993.993,0,0,0,.589-.286l8.923-8.922a2.579,2.579,0,0,0,.721-2.05A3.18,3.18,0,0,0,23.051.95,3.18,3.18,0,0,0,21.076.011Z",
    transform: "translate(-3.998 4)",
    fill: "#003984"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M17,24H3a3,3,0,0,1-3-3V18.48a1,1,0,1,1,2,0V21a1,1,0,0,0,1,1H17a1,1,0,0,0,1-1V19.544c.669.027-.066-.1,2-.128V21A3,3,0,0,1,17,24Z",
    fill: "#003984"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.32bf0f35c75decebc65e233ef8401ea5.svg";
export { ForwardRef as ReactComponent };